import { render, staticRenderFns } from "./FacturacionComponent.vue?vue&type=template&id=8483256a&scoped=true"
import script from "./FacturacionComponent.vue?vue&type=script&lang=js"
export * from "./FacturacionComponent.vue?vue&type=script&lang=js"
import style0 from "./FacturacionComponent.vue?vue&type=style&index=0&id=8483256a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8483256a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8483256a')) {
      api.createRecord('8483256a', component.options)
    } else {
      api.reload('8483256a', component.options)
    }
    module.hot.accept("./FacturacionComponent.vue?vue&type=template&id=8483256a&scoped=true", function () {
      api.rerender('8483256a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/openpay/FacturacionComponent.vue"
export default component.exports